import type { FC } from 'react';
import React from 'react';

import { CommonPhoneInput } from './common-phone-input';
import { validatePhone, validatePhoneReject940 } from './helpers';
import type { IPropsDcPhoneInput } from './models';

export const DcPhoneInput: FC<IPropsDcPhoneInput> = ({ rejectPhone940, ...props }) => {
    const validation = rejectPhone940 ? validatePhoneReject940 : validatePhone;

    return <CommonPhoneInput {...props} validatePhone={validation} />;
};
